import cn from 'classnames';
import { useEffect, useRef } from 'react';
import { useStore } from '@lib/state-engine';
import { Table, TableColumn } from '@consta/uikit/Table';
import { WarehouseSleeveList, WarehouseStationaryList } from '@ui/icons';
import { warehouseModel } from '@entities/warehouse';
import { $selectedWarehouseId, selectWarehouse, toggleSelectWarehouse } from '../model';
import { WarehousesList } from '../warehouses-list';

const columns: TableColumn<any>[] = [
  {
    title: '№',
    accessor: 'id',
    align: 'center',
    width: 100,
    sortable: true,
  },
  {
    title: '',
    renderCell: ({ type }) =>
      type === warehouseModel.WAREHOUSE_TYPES.stationary ? (
        <WarehouseStationaryList />
      ) : (
        <WarehouseSleeveList />
      ),
    width: 50,
    accessor: 'type',
  },
  {
    title: 'Название',
    accessor: 'name',
    sortable: true,
  },
  {
    title: 'Вес',
    accessor: 'totalWeight',
    sortable: true,
    renderCell: ({ totalWeight }) => `${Number(totalWeight).toFixed()} т`,
  },
];

export const WarehouseList = ({ className = '' }: { className?: string }) => {
  const selectedWarehouseId = useStore($selectedWarehouseId);
  const warehouses = useStore(warehouseModel.$allWarehouses);
  const tblRef = useRef(null);
  const resizerRef = useRef(
    new ResizeObserver(([e]) => {
      if (tblRef) {
        // console.log('width', e.contentRect.width);
      }
    }),
  );

  useEffect(() => {
    return () => resizerRef.current.disconnect();
  }, []);

  useEffect(() => {
    if (tblRef.current) {
      // resizerRef.current.observe(tblRef.current);
    }
  }, [tblRef.current]);

  const handleClickRow = ({
    id,
    e,
  }: {
    id: string | undefined;
    e?: React.SyntheticEvent;
  }): void => {
    console.log(id);
    // selectWarehouse(Number(id));
    toggleSelectWarehouse(id ? Number(id) : null);
  };

  return (
    // <Table
    //   className={cn([className])}
    //   rows={warehouses}
    //   columns={columns}
    //   activeRow={{
    //     id: selectedWarehouseId || undefined,
    //     onChange: handleClickRow,
    //   }}
    // />
    <WarehousesList
      activeWarehouse={selectedWarehouseId}
      warehouses={warehouses}
      columns={columns as any}
      onClickWarehouse={selectWarehouse}
    />
  );
};
